import { connect } from "react-redux"
import { withRouter } from "react-router"
import { Button, Card, Checkbox } from "semantic-ui-react"
import { ReactComponent as Tick } from "../../../images/tick-dynamic.svg"
import { ReactComponent as Door } from "../../../images/door.svg"
import React, { useMemo, useState } from "react"
import { routerPaths } from "../../../v1/constants/paths"
import { ReactComponent as Star } from "../../../images/star.svg"
import { BASIC } from "../../../v1/constants/tires"

const ActivateMembership = ({ history, membershipData, user }) => {
  const [acceptTerms, setAcceptTerms] = useState(false)

  const [showJustAHeadsUp, setShowJustAHeadsUp] = useState(false)

  const membership = useMemo(() => {
    if (!membershipData?.length) return null
    return [...membershipData].find((plan) => plan.name === "Premium")
  }, [membershipData])

  if (showJustAHeadsUp) {
    return <JustAHeadsUp setShowJustAHeadsUp={setShowJustAHeadsUp} history={history} />
  }

  const features = [
    `Get up to ${Math.trunc(membership?.percent_discount)}% off all service & repairs`,
    "Talk to a Master Mechanic, any time",
    `Manage up to ${membership?.max_num_vehicles} vehicles`
  ].filter(Boolean)

  if (!membership?.id) {
    return null
  }
  const isMembershipExpired =
    user.membership.plan_name === BASIC &&
    (user.total_shop_orders > 0 || user.active_orders.length > 0)

  return (
    <Card className="service-card activate-membership" raised>
      <div className="star-icon-wrapper">
        <Star />
      </div>

      <div className="card-header">
        <p className="title">
          {isMembershipExpired ? "Reactivate Premium status" : "Complete your account setup"}
        </p>
        <p style={{ fontSize: "16px" }}>
          {isMembershipExpired
            ? "Your Premium access has expired. Reactivate now to secure your service discounts."
            : "A Premium membership is required to secure your CarAdvise discount."}
        </p>
      </div>

      <div className="feature-list">
        <div className="membership-row">
          <p style={{ fontWeight: 600, fontFamily: "Inter", color: "#3C3C3C" }}>
            Premium membership
          </p>
          <p className="price">${membership.price} / month</p>
        </div>

        {features.map((feature, i) => (
          <div className="feature-item" key={i}>
            <Tick />
            <p>{feature}</p>
          </div>
        ))}
      </div>

      <div className="billing-box">
        <p className="billing-title">How billing works:</p>
        <p className="billing-description">
          Your membership fee will be charged today. Service charges will be billed separately when
          your shop sends the final quote.
        </p>
      </div>

      <div className="terms-section">
        <Checkbox
          className="custom-orange-checkbox"
          checked={acceptTerms}
          onChange={() => setAcceptTerms(!acceptTerms)}
        />
        <p>
          I agree to the{" "}
          <a href="https://caradvise.com/terms/" target="_blank">
            Terms and Conditions.
          </a>
          The ${membership.price} membership fee will be charged today.
        </p>
      </div>

      <div className="action_button">
        <Button
          fluid
          className="primary-button"
          disabled={!acceptTerms}
          onClick={() =>
            history.push({
              pathname: routerPaths.addPayment,
              search: "?activate_membership=true"
            })
          }
        >
          Continue to payment
        </Button>
      </div>
    </Card>
  )
}

const JustAHeadsUp = ({ setShowJustAHeadsUp, history }) => {
  return (
    <Card className="service-card just-a-heads-up" raised>
      <Door className="door-icon" />

      <p className="title">Just a heads up...</p>

      <p className="description">
        A Premium membership is required to get CarAdvise discounts.{" "}
        <span>You will not be able to proceed without an active membership.</span>
      </p>

      <Button fluid className="primary-button" onClick={() => setShowJustAHeadsUp(false)}>
        Continue with Premium
      </Button>

      <Button
        fluid
        basic
        color="black"
        className="secondary-button"
        onClick={() =>
          history.push({
            pathname: routerPaths.dashboard
          })
        }
      >
        Cancel & exit
      </Button>
    </Card>
  )
}

function mapStateToProps(state) {
  const { paymentMethods, membershipData, user } = state

  return {
    paymentMethods: paymentMethods.braintreePaymentMethods,
    membershipData: membershipData.availableMembershipPlans,
    activeMembershipPlan: user.membership || {},
    user: user || {}
  }
}

export default withRouter(connect(mapStateToProps)(ActivateMembership))
